import { Component, OnInit } from '@angular/core';
import { Products } from 'src/app/model/products.model';
import { ProductService } from 'src/app/services/product/product.service';
import { Router } from '@angular/router';
import { Productcategory } from 'src/app/model/productcategory.model';

@Component({
  selector: 'app-productlist',
  templateUrl: './productlist.component.html',
  styleUrls: ['./productlist.component.css']
})
export class ProductlistComponent implements OnInit {

  data: Products;

  product: any;
  productCopy : any;
  category: Productcategory;
  cartItems: any;
  filteredProduct: any;

  constructor(private productServices: ProductService, private router: Router) { }

  ngOnInit() {
    this.getProductList();
    this.getProductCategory();
  }

  getProductList() {
    this.productServices.getProductList().subscribe(
      (data: any) => {
        this.data = data;
        this.product = data;
        this.productCopy = data;
        console.log(this.data);
      }
    )
  }

  getProductCategory() {
    this.productServices.getProductCategory().subscribe(
      (data: any) => {
        this.category = data;
        console.log(this.category);
      }
    )
  }

  deleteproduct(productid: number) {
    this.productServices.deleteProduct(productid).subscribe(
      (data: any) => {
        if (data == true) {
          this.getProductList();
        }
      }
    )
  }

  editproduct(productid: number) {
    if (productid != null) {
      this.router.navigate(['/editproduct', productid]);
    }
  }

  onSelectCategory(catid) {
    this.filteredProduct = this.productCopy.filter(x => x.productCategoryId == catid);
    this.data = this.filteredProduct;
  }

  filterProductList(keyword)
  {
    this.productServices.filterProduct(keyword).subscribe(
      (data : any) => {
        this.data = data;
        console.log(data);
      }
    );
  }

}
